import { render, staticRenderFns } from "./PagesWidgetsList.vue?vue&type=template&id=67d98f78&"
import script from "./PagesWidgetsList.vue?vue&type=script&lang=js&"
export * from "./PagesWidgetsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports